define([
    'text!product-detail/page/gallery-page-content.html',
    'product-detail/gallery/knowledge-info',
    'product-detail/component/more-products',
    'product-detail/gallery/maintain-info',
    'product-detail/component/scene-list',
    'product-detail/component/sku-info',
    'product-detail/component/spec-info',
    'product-detail/gallery/brand-info',
    'product-detail/component/dimension-table',
    'product-detail/component/feature-list'
], function(
    tpl,
    KnowledgeInfo,
    MoreProducts,
    MaintainInfo,
    SceneList,
    SkuInfo,
    SpecInfo,
    BrandInfo,
    DimensionTable,
    FeatureList
){
    return {
        template: tpl,
        components: {
            KnowledgeInfo: KnowledgeInfo,
            MoreProducts: MoreProducts,
            MaintainInfo: MaintainInfo,
            SceneList: SceneList,
            SkuInfo: SkuInfo,
            SpecInfo: SpecInfo,
            BrandInfo: BrandInfo,
            DimensionTable: DimensionTable,
            FeatureList: FeatureList
        }
    };
});


//////////////////
// WEBPACK FOOTER
// ./product-detail2024/page/gallery-page-content.js
// module id = 320
// module chunks = 0